import moment from 'moment-timezone'

export default {
  methods: {
    buildGraphData(data) {
      const view = this
      let graphData = []
      data.forEach((item) => {
        let itemKey = Object.keys(item)[0],
          chartItem = item[itemKey],
          isAlreadyObject = typeof chartItem === 'object' && !!chartItem
        if (!isAlreadyObject) { chartItem = { amount: chartItem ? chartItem : 0 } }
        chartItem.date_time = view.formatDateTime(itemKey)
        graphData.push(chartItem)
      })

      if (graphData.length == 1) {
        graphData[graphData.length - 1].final_end_time = view.formatDateTime(moment.utc().add(1, 'hours'))
      } else if (graphData.length > 1) {
        const secondLastStartTime = moment.utc(Object.keys(data[data.length - 2])[0])
        const lastStartTime = moment.utc(Object.keys(data[data.length - 1])[0])

        const hourDiff = lastStartTime.diff(secondLastStartTime, 'hours')
        let futureEndTime = lastStartTime.add(hourDiff, 'hours')

        if (moment.utc().diff(futureEndTime) < 0) {
          futureEndTime = moment.utc().add(1, 'hours');
        }

        graphData[graphData.length - 1].final_end_time = view.formatDateTime(futureEndTime)
      }
      return graphData
    },

    configureDisplayDate(momentDateTime) {
      let displayDate = this.advertiserTimezone ? momentDateTime.tz(this.advertiserTimezone) : momentDateTime,
        shortTime = displayDate.hour() > 11 ? `${displayDate.format('h')}p` : `${displayDate.format('h')}a`,
        shortDate = displayDate.format('M/D')
      return `${shortDate} ${shortTime}`
    },

    createDateTicks(max, min, timeIncrement, timeType) {
      let incrementDate = min.clone(),
        ticks = []
      while (incrementDate.isBefore(max)) {
        ticks.push(this.configureDisplayDate(incrementDate))
        incrementDate = incrementDate.clone().add(timeIncrement, timeType)
      }
      return ticks
    },

    formatDateTime(dateTime) {
      return this.configureDisplayDate(moment.utc(dateTime, 'YYYY-MM-DD HH:mm:ss'))
    },

    getStartEndDates(data, graphType) {
      const isTrends = graphType === 'trends'
      if (isTrends && data.length > 12) {
        let momentDateTimes = []

        data.forEach((item) => momentDateTimes.push(moment.utc(Object.keys(item)[0], 'YYYY-MM-DD HH:mm:ss')) )

        const maxDate = moment.max(momentDateTimes),
          minDate = moment.min(momentDateTimes)

        if (data.length > 12) {
          const range = moment.duration(maxDate.diff(minDate)),
            timeIncrement = range.asSeconds() / 11
          this.$set(this[graphType], 'dateTicks', this.createDateTicks(maxDate, minDate, timeIncrement, 'seconds'))
        }
      } else if (isTrends && this[graphType].dateTicks) {
        this.$delete(this[graphType], 'dateTicks')
      }
    },
  },

  mounted() {
    this.setWrapperWidths()
    window.addEventListener('resize', this.setWrapperWidths)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setWrapperWidths)
  },
}